import { SearchableSelectType } from '../components/inputs/searchableSelect';

import { FormulaType } from '../constants/formulaType';

import { CompoundTriggerType } from './compound-trigger.model';
import { PerformanceMetricsModel } from './metrics.model';
import { BasePaginatedResponse } from './pagination';

export const COMPOUND_TRIGGER_TYPE_LABELS: Record<CompoundTriggerType, string> =
    {
        [CompoundTriggerType.AAMPE_OPTIMISED]: 'Aampe optimised',
        [CompoundTriggerType.SEND_IMMEDIATELY]: 'Immediate',
        [CompoundTriggerType.SEND_WITH_DELAY]: 'Delayed',
    };

export interface LiveMessageBase {
    id: number;
    name: string;
    compound_trigger_type?: CompoundTriggerType;
}

export interface LiveMessageFormulaModel extends PerformanceMetricsModel {
    formula: LiveMessageBase;
}
export interface LiveMessageModel {
    metrics: LiveMessageFormulaModel[];
    latest_date?: string;
}

export interface PaginatedFormulaLiveMessageMetadata {
    latest_date?: string;
}

export interface PaginatedFormulaLiveMessageModel
    extends BasePaginatedResponse<LiveMessageFormulaModel> {
    metadata?: PaginatedFormulaLiveMessageMetadata;
}

export interface LiveMessageLabelBase {
    id: number;
    label_name: string;
    variant_type: string;
}

export interface LiveMessageLabelMetricsBase
    extends LiveMessageLabelBase,
        PerformanceMetricsModel {
    subRows?: LiveMessageLabelMetricsBase[];
}

export interface LiveMessageLabelModel {
    metrics: {
        formula: LiveMessageBase;
        labels: LiveMessageLabelMetricsBase[];
    };
    latest_date?: string;
}

interface LiveMessageVariantBase {
    id: string;
    text: string;
}

export interface LiveMessageVariantMetricsModel
    extends LiveMessageVariantBase,
        PerformanceMetricsModel {}
export interface LiveMessageVariantModel {
    metrics: {
        formula: LiveMessageBase;
        label: LiveMessageLabelBase;
        variations: LiveMessageVariantMetricsModel[];
    };
    latest_date?: string;
}

export enum ViewByName {
    RATE = 'percentage',
    COUNT = 'count',
}

export const LiveMessageViewByOptions: SearchableSelectType[] = [
    { value: ViewByName.RATE, label: 'Percentage' },
    { value: ViewByName.COUNT, label: 'Raw count' },
];

export enum LivePerformanceEmptyStateAnimation {
    ROBOT = 'robot',
    CLUSTER = 'cluster',
    SCHEDULING_IN_PROGRESS = 'scheduling_in_progress',
    MESSAGE_ON_THEIR_WAY = 'message_on_their_way',
    PROCESSING_PERFORMANCE_DATA = 'processing_performance_data',
}
export interface LivePerformanceEmptyStateStepperModel {
    value: string | number;
    label: string;
    isLoading: boolean;
}

export enum LivePerformanceMessageState {
    SCHEDULED = 'SCHEDULED',
    IN_PROGRESS = 'IN PROGRESS',
    SENT = 'SENT',
}

export interface AgentWorkingDataModel {
    text: string;
    isLoading: boolean;
}

export interface LivePerformanceEmptyStateModel {
    heading: string;
    description: string;
    animation: Object;
    agentWorkingData: AgentWorkingDataModel[];
}

export enum MessagePerformanceStatus {
    Live = 'Live',
    Expired = 'Expired',
    Archived = 'Archived',
}

export const MessagePerformanceAllStatus = {
    All: 'All',
    ...MessagePerformanceStatus,
};

export const MessagePerformanceStatusOptions = [
    {
        label: MessagePerformanceStatus.Live,
        value: MessagePerformanceStatus.Live,
    },
    {
        label: MessagePerformanceStatus.Expired,
        value: MessagePerformanceStatus.Expired,
    },
    {
        label: MessagePerformanceStatus.Archived,
        value: MessagePerformanceStatus.Archived,
    },
];

export const MessagePerformanceStatusAllOptions = [
    {
        label: MessagePerformanceAllStatus.All,
        value: MessagePerformanceAllStatus.All,
    },
    ...MessagePerformanceStatusOptions,
];

export interface PerformanceFilterFormikValues {
    message_status?: MessagePerformanceStatus[];
    tag_ids?: string[];
}

export interface PerformanceFilterParams {
    messageType?: FormulaType;
    dateFrom?: string;
    dateTo?: string;
    formulaStatuses?: MessagePerformanceStatus[];
    tagIds?: string[];
    search?: string;
}

export interface LiveMessagesGraphMetricsModel {
    num_messages_sent_count: number;
    notification_opened_successful_messages_sent_percentage?: number;
    email_click_successful_messages_sent_percentage?: number;
    formula_count: number;
    metric_date: string;
}
